import * as Sentry from '@sentry/react';

type SentryEnv = {
  VITE_SENTRY_DSN?: string;
  VITE_SENTRY_RELEASE?: string;
  VITE_SENTRY_ENVIRONMENT?: string;
};

export function initSentry(env: SentryEnv): void {
  if (!env.VITE_SENTRY_DSN) {
    return;
  }
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    release: env.VITE_SENTRY_RELEASE,
    environment: env.VITE_SENTRY_ENVIRONMENT,
  });
}
